export const MAX_COMBINED_FACET = 2;
